import React from 'react';

import GiftPage from '@edx/pages/gift';

const bgImage = {
  small: '/img/gifts/gifts_heading-s.jpg',
  medium: '/img/gifts/gifts_heading-m.jpg',
  large: '/img/gifts/gifts_heading-l.jpg',
};

const RegalaEDBPage: React.FC = () => <GiftPage bgImage={bgImage} />;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
RegalaEDBPage.navBar = { position: 'absolute', variant: 'transparent' };

export default RegalaEDBPage;
